import { getEnvVar } from '@nucleus/lib-environment';
import { Stage } from '@nucleus/ncu-constants';
import { getTableName } from '@nucleus/src-platform/constant/dynamodb';

export const TABLE_NAME_CHURCHPERSON = getTableName('churchperson', 'NucleusPlatformResources', Stage);
export const TABLE_NAME_DESIGNATION = getTableName('designation', 'NucleusGivingResources', Stage);
export const TABLE_NAME_FLOW = getTableName('flow', 'NucleusGivingResources', Stage);
export const TABLE_NAME_FLOWURL = getTableName('flowurl', 'NucleusGivingResources', Stage);
export const TABLE_NAME_GIFTSCHEDULE = getTableName('giftschedule', 'NucleusGivingResources', Stage);
export const TABLE_NAME_MERCHANT = getTableName('merchant', 'NucleusGivingResources', Stage);
export const TABLE_NAME_PRODUCTGIVING = getTableName('productgiving', 'NucleusGivingResources', Stage);
export const TABLE_NAME_SOURCE = getTableName('source', 'NucleusGivingResources', Stage);
export const TABLE_NAME_STATEMENT = getTableName('statement', 'NucleusGivingResources', Stage);
export const TABLE_NAME_TRANSACTION = getTableName('transaction', 'NucleusGivingResources', Stage);
export const TABLE_NAME_TRANSFER = getTableName('transfer', 'NucleusGivingResources', Stage);

export const GIVING_FLOW_COLOR_MODE_LIGHT = 'GIVING_FLOW_COLOR_MODE_LIGHT';
export const GIVING_FLOW_COLOR_MODE_DARK = 'GIVING_FLOW_COLOR_MODE_DARK';
export const GIVING_FLOW_COLOR_MODES = Object.freeze([GIVING_FLOW_COLOR_MODE_LIGHT, GIVING_FLOW_COLOR_MODE_DARK]);
export const GIVING_FLOW_BUTTON_POSITION_LEFT = 'GIVING_FLOW_BUTTON_POSITION_LEFT';
export const GIVING_FLOW_BUTTON_POSITION_RIGHT = 'GIVING_FLOW_BUTTON_POSITION_RIGHT';
export const GIVING_FLOW_BUTTON_POSITIONS = Object.freeze([
  GIVING_FLOW_BUTTON_POSITION_LEFT,
  GIVING_FLOW_BUTTON_POSITION_RIGHT,
]);
export const GIVING_FLOW_ICON_REBELGIVE = 'rebelgivelogo';
export const GIVING_FLOW_ICON_GIVE = 'give';
export const GIVING_FLOW_TRIGGER_ICONS = Object.freeze([GIVING_FLOW_ICON_REBELGIVE, GIVING_FLOW_ICON_GIVE]);

export const enum GivingFeature {
  SubmitMerchantApplication = 'SubmitMerchantApplication',
}

export type GivingFeatures = Record<GivingFeature, boolean>;

export const DYNAMODB_EVENT = Object.freeze({
  Insert: 'INSERT',
  Modify: 'MODIFY',
  Remove: 'REMOVE',
});

export enum DesignationAvailableIn {
  Flows = 'flows',
  Giving = 'giving',
}
export const AVAILABLE_IN_BLANK = '_blank_';

// You cannot get more than 100 items at a time.
export const DYNAMODB_BATCH_GET_MAX_ITEMS = 100;
// You cannot write more than 25 items at a time, applies to batchDelete operations too.
export const DYNAMODB_BATCH_WRITE_MAX_ITEMS = 25;

export const MAX_ITEMS_LISTED = Math.min(parseInt(getEnvVar('MAX_ITEMS_LISTED', '100'), DYNAMODB_BATCH_GET_MAX_ITEMS));
export const WELCOME_GIVER_EMAIL_DELAY_MINUTES = parseInt(getEnvVar('WELCOME_GIVER_EMAIL_DELAY_MINUTES', '15'));
export const PROFILE_EMAIL_DELAY_MINUTES = parseInt(getEnvVar('PROFILE_EMAIL_DELAY_MINUTES', '1440'));
export const AUTO_CREATE_ACCOUNT_DELAY_MINUTES = parseInt(getEnvVar('AUTO_CREATE_ACCOUNT_DELAY_MINUTES', '1440'));
// A little over 77 minutes offsets to non-consistant times each day. When we do this in batches
// and deposits this will no longer matter.
export const TRANSACTION_POLL_DELAY_MINUTES = parseInt(getEnvVar('TRANSACTION_POLL_DELAY_MINUTES', '77'));

// Number of days past that transferPoll will ask Rebelpay for
export const TRANSFER_POLL_DAYS_TO_LOOK_BACK = parseInt(getEnvVar('TRANSFER_POLL_DAYS_TO_LOOK_BACK', '90'));

// Number of days past closing a merchant that we will update it.
export const TRANSFER_POLL_DAYS_UPDATE_CLOSED_MERCHANT = parseInt(
  getEnvVar('TRANSFER_POLL_DAYS_UPDATE_CLOSED_MERCHANT', '45')
);

// Number of days past that transferPoll will ask Rebelpay for
export const TRANSFER_POLL_MAX_CONCURRENT = parseInt(getEnvVar('TRANSFER_POLL_MAX_CONCURRENT', '25'));

// The maximum amount of time between a transaction being given and a user being able to claim the
// payment source as theirs.
export const SOURCE_CLAIM_WINDOW_MINUTES = parseInt(getEnvVar('SOURCE_CLAIM_WINDOW_MINUTES', '15'));

// Claims should not be auto claimed any sooner than the claim window expiring.
export const TRANSACTION_CLAIM_DELAY_MINUTES = Math.max(
  parseInt(getEnvVar('TRANSACTION_CLAIM_DELAY_MINUTES', '20'), SOURCE_CLAIM_WINDOW_MINUTES)
);

export const FLOW_ORIGIN_WHITELIST = Object.freeze(
  getEnvVar('FLOW_ORIGIN_WHITELIST', '')
    .toLowerCase()
    .split(',')
    .map((origin: string) => origin.trim())
);

export const GOOGLE_MAPS_API_KEY = getEnvVar('GOOGLE_MAPS_API_KEY');
export const MERCHANT_SITE_EMAIL = getEnvVar('MERCHANT_SITE_EMAIL');

export const REBELPAY_API_BASE_URL = getEnvVar('REBELPAY_API_BASE_URL');
export const REBELPAY_API_KEY_SECRET = getEnvVar('REBELPAY_API_KEY_SECRET');
export const REBELPAY_API_KEY_PUBLIC = getEnvVar('REBELPAY_API_KEY_PUBLIC');

export const enum Interval {
  Day = 'INTERVAL_DAY',
  Week = 'INTERVAL_WEEK',
  Month = 'INTERVAL_MONTH',
  Dates = 'INTERVAL_DATES',
}

export const INTERVAL_DAY = Interval.Day;
export const INTERVAL_WEEK = Interval.Week;
export const INTERVAL_MONTH = Interval.Month;
export const INTERVAL_DATES = Interval.Dates;

export const INTERVALS = Object.freeze([INTERVAL_DAY, INTERVAL_WEEK, INTERVAL_MONTH, INTERVAL_DATES]);

export const SCHEDULE_START_DATE_MAXIMUM_FUTURE_MONTHS = 9;

export const enum TRANSACTION_CHARGE_STATUS {
  tsu = 'tsu',
  tsf = 'tsf',
  tsa = 'tsa',
}
export const TRANSACTION_CHARGE_STATUS_UNTRIED = TRANSACTION_CHARGE_STATUS.tsu; // have not tried to collect using RebelPay
export const TRANSACTION_CHARGE_STATUS_FAILED = TRANSACTION_CHARGE_STATUS.tsf; // no RebelPay charge created
export const TRANSACTION_CHARGE_STATUS_ACCEPTED = TRANSACTION_CHARGE_STATUS.tsa; // RebelPay charge created
export const TRANSACTION_CHARGE_STATUSES: Readonly<Array<TRANSACTION_CHARGE_STATUS>> = Object.freeze([
  TRANSACTION_CHARGE_STATUS_UNTRIED,
  TRANSACTION_CHARGE_STATUS_FAILED,
  TRANSACTION_CHARGE_STATUS_ACCEPTED,
]);

// User facing statuses.
export const TRANSACTION_STATUS_PENDING = 'Pending'; // Pending
export const TRANSACTION_STATUS_SUCCEEDED = 'Successful'; // Successful
export const TRANSACTION_STATUS_PAIDOUT = 'Paid Out'; // Paid Out
export const TRANSACTION_STATUS_REFUNDED = 'Refunded'; // Refunded
export const TRANSACTION_STATUS_FAILED = 'Failed'; // Failed
export const TRANSACTION_STATUSES = Object.freeze([
  TRANSACTION_STATUS_PENDING,
  TRANSACTION_STATUS_SUCCEEDED,
  TRANSACTION_STATUS_PAIDOUT,
  TRANSACTION_STATUS_REFUNDED,
  TRANSACTION_STATUS_FAILED,
]);
export const FILTER_STATUS_PENDING = 'pending';
export const FILTER_STATUS_SUCCEEDED = 'succeeded';
export const FILTER_STATUS_PAIDOUT = 'paidout';
export const FILTER_STATUS_REFUNDED = 'refunded';
export const FILTER_STATUS_FAILED = 'failed';
export const FILTER_STATUS_DEPOSITED = 'deposited'; // Deprecated.
export const FILTER_STATUSES = Object.freeze([
  FILTER_STATUS_PENDING,
  FILTER_STATUS_SUCCEEDED,
  FILTER_STATUS_PAIDOUT,
  FILTER_STATUS_REFUNDED,
  FILTER_STATUS_FAILED,
  FILTER_STATUS_DEPOSITED,
]);

export const FILTER_DATE_GIVEN = 'date_given';
export const FILTER_DATE_DEPOSITED = 'date_deposited';
export const FILTER_DATE_PAIDOUT = 'date_paidout';
export const FILTER_DATES = [FILTER_DATE_GIVEN, FILTER_DATE_PAIDOUT];
export const FILTER_DATE_NAME_MAP = Object.freeze({
  [FILTER_DATE_GIVEN]: 'Given',
  [FILTER_DATE_DEPOSITED]: 'Deposited',
  [FILTER_DATE_PAIDOUT]: 'Paid out',
});
export const FILTER_FREQUENCY_ONE_TIME = 'one_time';
export const FILTER_FREQUENCY_RECURRING = 'recurring';
export const FILTER_FREQUENCIES = Object.freeze([FILTER_FREQUENCY_ONE_TIME, FILTER_FREQUENCY_RECURRING]);

export const FILTER_SCHEDULE_STATUS_ACTIVE = 'active';
export const FILTER_SCHEDULE_STATUS_INACTIVE = 'inactive';

export const FILTER_SORT_DIRECTION_DESCENDING = 'Desc';
export const FILTER_SORT_DIRECTION_ASCENDING = 'Asc';
export const FILTER_SORT_DIRECTIONS = Object.freeze([
  FILTER_SORT_DIRECTION_DESCENDING,
  FILTER_SORT_DIRECTION_ASCENDING,
]);

export const DAY_OF_THE_WEEK_TO_NAME_MAP = Object.freeze([
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
]);

export const STATEMENT_STATUS_INACTIVE = 'Inactive';
export const STATEMENT_STATUS_INCOMPLETE = 'Incomplete';
export const STATEMENT_STATUS_COMPLETED = 'Completed';

export const COUNTRY_USA = 'US';
export const COUNTRY_CANADA = 'CA';
export const COUNTRIES = Object.freeze([COUNTRY_USA, COUNTRY_CANADA]);

export enum CURRENCY {
  USD = 'USD',
  CAD = 'CAD',
}
export const CURRENCY_US_DOLLAR = CURRENCY.USD;
export const CURRENCY_CANADIAN_DOLLAR = CURRENCY.CAD;
export const CURRENCIES: Readonly<Array<CURRENCY>> = Object.freeze([CURRENCY_US_DOLLAR, CURRENCY_CANADIAN_DOLLAR]);

export const CURRENCY_COUNTRY_MAP = Object.freeze({
  [CURRENCY_US_DOLLAR]: COUNTRY_USA,
  [CURRENCY_CANADIAN_DOLLAR]: COUNTRY_CANADA,
});

export const PROCESSOR_CARDCONNECT = 'processor_cardconnect';
export const PROCESSORS = Object.freeze([PROCESSOR_CARDCONNECT]);

export const SOURCE_TYPE_ACH_DEBIT = 'ach_debit';
export const SOURCE_TYPE_CARD = 'card';
export const SOURCE_TYPE_CASH = 'cash';
export const SOURCE_TYPE_CHECK = 'check';
export const SOURCE_TYPE_OTHER = 'other';

export const SOURCE_TYPES = Object.freeze([
  SOURCE_TYPE_ACH_DEBIT,
  SOURCE_TYPE_CARD,
  SOURCE_TYPE_CASH,
  SOURCE_TYPE_CHECK,
  SOURCE_TYPE_OTHER,
]);

export const SOURCE_TYPE_NAME_MAP = Object.freeze({
  [SOURCE_TYPE_ACH_DEBIT]: 'ACH',
  [SOURCE_TYPE_CARD]: 'Credit Card',
  [SOURCE_TYPE_CASH]: 'Cash',
  [SOURCE_TYPE_CHECK]: 'Check',
  [SOURCE_TYPE_OTHER]: 'Other',
});

export const TOKEN_CREATION_KEY_BANK = 'bank_account';
export const TOKEN_CREATION_KEY_CARD = 'card';
export const TOKEN_CREATION_KEYS = Object.freeze([TOKEN_CREATION_KEY_CARD, TOKEN_CREATION_KEY_BANK]);

export const MERCHANT_PROGRAM_NUCLEUS_GIVING = 'MERCHANT_PROGRAM_NUCLEUS_GIVING';
export const MERCHANT_PROGRAM_NUCLEUS_BILLING = 'MERCHANT_PROGRAM_NUCLEUS_BILLING';
export const MERCHANT_PROGRAMS = Object.freeze([MERCHANT_PROGRAM_NUCLEUS_GIVING, MERCHANT_PROGRAM_NUCLEUS_BILLING]);

export const BANK_NUMBER_FORMAT_ACH = 'ACH';
export const BANK_NUMBER_FORMAT_EFT = 'EFT';
export const BANK_NUMBER_FORMATS = Object.freeze([BANK_NUMBER_FORMAT_ACH, BANK_NUMBER_FORMAT_EFT]);

export const BANK_ACCOUNT_TYPE_BUSINESS = 'BIZ';
export const BANK_ACCOUNT_TYPE_CHECKING = 'GL';
export const BANK_ACCOUNT_TYPE_SAVINGS = 'SAVINGS';
export const BANK_ACCOUNT_TYPES = Object.freeze([
  BANK_ACCOUNT_TYPE_BUSINESS,
  BANK_ACCOUNT_TYPE_CHECKING,
  BANK_ACCOUNT_TYPE_SAVINGS,
]);

export const VOID_REASON_INSUFFICIENT_FUNDS = 'insufficient_funds';
export const VOID_REASON_ACCOUNT_CLOSED = 'account_closed';
export const VOID_REASON_ACCOUNT_NOT_FOUND = 'no_account';
export const VOID_REASON_ACCOUNT_INVALID = 'account_invalid';
export const VOID_REASON_UNAUTHORIZED_CORPORATE_DEBIT_TO_CONSUMER_ACCOUNT =
  'unauthorized_corporate_debit_to_consumer_account';
export const VOID_REASON_RETURNED_PER_ODFI_REQUEST = 'returned_per_odfi_request';
export const VOID_REASON_AUTHORIZATION_REVOKED_BY_CUSTOMER = 'authorization_revoked_by_customer';
export const VOID_REASON_PAYMENT_STOPPED = 'payment_stopped';
export const VOID_REASON_UNCOLLECTED_FUNDS = 'uncollected_funds';
export const VOID_REASON_CUSTOMER_ADVISES_NOT_AUTHORIZED = 'customer_advises_not_authorized';
export const VOID_REASON_CHECK_TRUNCATION_ENTRY_RETURN_SPECIFY = 'check_truncation_entry_return_specify';
export const VOID_REASON_ACCOUNT_SOLD_TO_ANOTHER_DFI = 'account_sold_to_another_dfi';
export const VOID_REASON_INVALID_ACH_ROUTING_NUMBER = 'invalid_ach_routing_number';
export const VOID_REASON_REP_PAYEE_DECEASED_OR_INCAPACITATED = 'rep_payee_deceased_or_incapacitated';
export const VOID_REASON_BENEFICIARY_OR_ACCOUNT_HOLDER_DECEASED = 'beneficiary_or_account_holder_deceased';
export const VOID_REASON_ACCOUNT_FROZEN_OR_ENTRY_RETURNED_PER_OFAC_INSTRUCTION =
  'account_frozen_or_entry_returned_per_ofac_instruction';
export const VOID_REASON_FILE_RECORD_EDIT_CRITERIA_SPECIFY = 'file_record_edit_criteria_specify';
export const VOID_REASON_IMPROPER_EFFECTIVE_ENTRY_DATE = 'improper_effective_entry_date';
export const VOID_REASON_AMOUNT_FIELD_ERROR = 'amount_field_error';
export const VOID_REASON_NON_TRANSACTION_ACCOUNT = 'non_transaction_account';
export const VOID_REASON_INVALID_COMPANY_IDENTIFICATION = 'invalid_company_identification';
export const VOID_REASON_INVALID_INDIVIDUAL_ID_NUMBER = 'invalid_individual_id_number';
export const VOID_REASON_CREDIT_ENTRY_REFUSED_BY_RECEIVER = 'credit_entry_refused_by_receiver';
export const VOID_REASON_DUPLICATE_ENTRY = 'duplicate_entry';
export const VOID_REASON_ADDENDA_ERROR = 'addenda_error';
export const VOID_REASON_MANDATORY_FIELD_ERROR = 'mandatory_field_error';
export const VOID_REASON_TRACE_NUMBER_ERROR = 'trace_number_error';
export const VOID_REASON_ROUTING_NUMBER_OR_CHECK_DIGIT_ERROR = 'routing_number_or_check_digit_error';
export const VOID_REASON_CORPORATE_CUSTOMER_ADVISES_NOT_AUTHORIZED = 'corporate_customer_advises_not_authorized';
export const VOID_REASON_RDFI_NOT_PARTICIPANT_IN_CHECK_TRUNCATION_PROGRAM =
  'rdfi_not_participant_in_check_truncation_program';
export const VOID_REASON_PERMISSIBLE_RETURN_ENTRY_CCD_CTX = 'permissible_return_entry_ccd_ctx';
export const VOID_REASON_RDFI_NON_SETTLEMENT = 'rdfi_non_settlement';
export const VOID_REASON_RETURN_OF_XCK_ENTRY = 'return_of_xck_entry';
export const VOID_REASON_LIMITED_PARTICIPATION_DFI = 'limited_participation_dfi';
export const VOID_REASON_RETURN_OF_IMPROPER_DEBIT_ENTRY = 'return_of_improper_debit_entry';
export const VOID_REASON_RETURN_OF_IMPROPER_CREDIT_ENTRY = 'return_of_improper_credit_entry';
export const VOID_REASON_SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT_ARC_POP_BOC =
  'source_document_presented_for_payment_arc_pop_boc';
export const VOID_REASON_STOP_PAYMENT_ON_SOURCE_DOCUMENT_ARC_BOC = 'stop_payment_on_source_document_arc_boc';
export const VOID_REASON_IMPROPER_SOURCE_DOCUMENT_ARC_POP_BOC = 'improper_source_document_arc_pop_boc';
export const VOID_REASON_RETURN_OF_ENR_ENTRY_BY_FEDERAL_GOVERNMENT_AGENCY =
  'return_of_enr_entry_by_federal_government_agency';
export const VOID_REASON_INVALID_TRANSACTION_CODE = 'invalid_transaction_code';
export const VOID_REASON_ROUTING_NUMBER_OR_CHECK_DIGIT_ERROR_2 = 'routing_number_or_check_digit_error_2';
export const VOID_REASON_INVALID_DFI_ACCOUNT_NUMBER = 'invalid_dfi_account_number';
export const VOID_REASON_INVALID_INDIVIDUAL_ID_NUMBER_OR_IDENTIFICATION_NUMBER =
  'invalid_individual_id_number_or_identification_number';
export const VOID_REASON_INVALID_INDIVIDUAL_NAME_OR_COMPANY_NAME = 'invalid_individual_name_or_company_name';
export const VOID_REASON_INVALID_REPRESENTATIVE_PAYEE_INDICATOR = 'invalid_representative_payee_indicator';
export const VOID_REASON_DUPLICATE_ENROLLMENT = 'duplicate_enrollment';
export const VOID_REASON_STATE_LAW_AFFECTING_RCK_ACCEPTANCE = 'state_law_affecting_rck_acceptance';
export const VOID_REASON_ITEM_RELATED_TO_RCK_ENTRY_IS_INELIGIBLE_OR_RCK_ENTRY_IS_IMPROPER =
  'item_related_to_rck_entry_is_ineligible_or_rck_entry_is_improper';
export const VOID_REASON_STOP_PAYMENT_ON_ITEM_RCK = 'stop_payment_on_item_rck';
export const VOID_REASON_ITEM_AND_RCK_ENTRY_PRESENTED_FOR_PAYMENT = 'item_and_rck_entry_presented_for_payment';
export const VOID_REASON_MISROUTED_RETURN = 'misrouted_return';
export const VOID_REASON_RETURN_OF_ERRONEOUS_OR_REVERSING_DEBIT = 'return_of_erroneous_or_reversing_debit';
export const VOID_REASON_DUPLICATE_RETURN = 'duplicate_return';
export const VOID_REASON_UNTIMELY_RETURN = 'untimely_return';
export const VOID_REASON_FIELD_ERRORS = 'field_errors';
export const VOID_REASON_PERMISSIBLE_RETURN_ENTRY_NOT_ACCEPTED_OR_RETURN_NOT_REQUESTED_BY_ODFI =
  'permissible_return_entry_not_accepted_or_return_not_requested_by_odfi';
export const VOID_REASON_MISROUTED_DISHONORED_RETURN = 'misrouted_dishonored_return';
export const VOID_REASON_UNTIMELY_DISHONORED_RETURN = 'untimely_dishonored_return';
export const VOID_REASON_TIMELY_ORIGINAL_RETURN = 'timely_original_return';
export const VOID_REASON_CORRECTED_RETURN = 'corrected_return';
export const VOID_REASON_RETURN_NOT_A_DUPLICATE = 'return_not_a_duplicate';
export const VOID_REASON_NO_ERRORS_FOUND = 'no_errors_found';
export const VOID_REASON_NON_ACCEPTANCE_OF_R62_DISHONORED_RETURN = 'non_acceptance_of_r62_dishonored_return';
export const VOID_REASON_UNSUCCESSFUL = 'transaction_unsuccessful';

export const VOID_REASONS: Readonly<Array<string>> = Object.freeze([
  VOID_REASON_INSUFFICIENT_FUNDS,
  VOID_REASON_ACCOUNT_CLOSED,
  VOID_REASON_ACCOUNT_NOT_FOUND,
  VOID_REASON_ACCOUNT_INVALID,
  VOID_REASON_UNAUTHORIZED_CORPORATE_DEBIT_TO_CONSUMER_ACCOUNT,
  VOID_REASON_RETURNED_PER_ODFI_REQUEST,
  VOID_REASON_AUTHORIZATION_REVOKED_BY_CUSTOMER,
  VOID_REASON_PAYMENT_STOPPED,
  VOID_REASON_UNCOLLECTED_FUNDS,
  VOID_REASON_CUSTOMER_ADVISES_NOT_AUTHORIZED,
  VOID_REASON_CHECK_TRUNCATION_ENTRY_RETURN_SPECIFY,
  VOID_REASON_ACCOUNT_SOLD_TO_ANOTHER_DFI,
  VOID_REASON_INVALID_ACH_ROUTING_NUMBER,
  VOID_REASON_REP_PAYEE_DECEASED_OR_INCAPACITATED,
  VOID_REASON_BENEFICIARY_OR_ACCOUNT_HOLDER_DECEASED,
  VOID_REASON_ACCOUNT_FROZEN_OR_ENTRY_RETURNED_PER_OFAC_INSTRUCTION,
  VOID_REASON_FILE_RECORD_EDIT_CRITERIA_SPECIFY,
  VOID_REASON_IMPROPER_EFFECTIVE_ENTRY_DATE,
  VOID_REASON_AMOUNT_FIELD_ERROR,
  VOID_REASON_NON_TRANSACTION_ACCOUNT,
  VOID_REASON_INVALID_COMPANY_IDENTIFICATION,
  VOID_REASON_INVALID_INDIVIDUAL_ID_NUMBER,
  VOID_REASON_CREDIT_ENTRY_REFUSED_BY_RECEIVER,
  VOID_REASON_DUPLICATE_ENTRY,
  VOID_REASON_ADDENDA_ERROR,
  VOID_REASON_MANDATORY_FIELD_ERROR,
  VOID_REASON_TRACE_NUMBER_ERROR,
  VOID_REASON_ROUTING_NUMBER_OR_CHECK_DIGIT_ERROR,
  VOID_REASON_CORPORATE_CUSTOMER_ADVISES_NOT_AUTHORIZED,
  VOID_REASON_RDFI_NOT_PARTICIPANT_IN_CHECK_TRUNCATION_PROGRAM,
  VOID_REASON_PERMISSIBLE_RETURN_ENTRY_CCD_CTX,
  VOID_REASON_RDFI_NON_SETTLEMENT,
  VOID_REASON_RETURN_OF_XCK_ENTRY,
  VOID_REASON_LIMITED_PARTICIPATION_DFI,
  VOID_REASON_RETURN_OF_IMPROPER_DEBIT_ENTRY,
  VOID_REASON_RETURN_OF_IMPROPER_CREDIT_ENTRY,
  VOID_REASON_SOURCE_DOCUMENT_PRESENTED_FOR_PAYMENT_ARC_POP_BOC,
  VOID_REASON_STOP_PAYMENT_ON_SOURCE_DOCUMENT_ARC_BOC,
  VOID_REASON_IMPROPER_SOURCE_DOCUMENT_ARC_POP_BOC,
  VOID_REASON_RETURN_OF_ENR_ENTRY_BY_FEDERAL_GOVERNMENT_AGENCY,
  VOID_REASON_INVALID_TRANSACTION_CODE,
  VOID_REASON_ROUTING_NUMBER_OR_CHECK_DIGIT_ERROR_2,
  VOID_REASON_INVALID_DFI_ACCOUNT_NUMBER,
  VOID_REASON_INVALID_INDIVIDUAL_ID_NUMBER_OR_IDENTIFICATION_NUMBER,
  VOID_REASON_INVALID_INDIVIDUAL_NAME_OR_COMPANY_NAME,
  VOID_REASON_INVALID_REPRESENTATIVE_PAYEE_INDICATOR,
  VOID_REASON_DUPLICATE_ENROLLMENT,
  VOID_REASON_STATE_LAW_AFFECTING_RCK_ACCEPTANCE,
  VOID_REASON_ITEM_RELATED_TO_RCK_ENTRY_IS_INELIGIBLE_OR_RCK_ENTRY_IS_IMPROPER,
  VOID_REASON_STOP_PAYMENT_ON_ITEM_RCK,
  VOID_REASON_ITEM_AND_RCK_ENTRY_PRESENTED_FOR_PAYMENT,
  VOID_REASON_MISROUTED_RETURN,
  VOID_REASON_RETURN_OF_ERRONEOUS_OR_REVERSING_DEBIT,
  VOID_REASON_DUPLICATE_RETURN,
  VOID_REASON_UNTIMELY_RETURN,
  VOID_REASON_FIELD_ERRORS,
  VOID_REASON_PERMISSIBLE_RETURN_ENTRY_NOT_ACCEPTED_OR_RETURN_NOT_REQUESTED_BY_ODFI,
  VOID_REASON_MISROUTED_DISHONORED_RETURN,
  VOID_REASON_UNTIMELY_DISHONORED_RETURN,
  VOID_REASON_TIMELY_ORIGINAL_RETURN,
  VOID_REASON_CORRECTED_RETURN,
  VOID_REASON_RETURN_NOT_A_DUPLICATE,
  VOID_REASON_NO_ERRORS_FOUND,
  VOID_REASON_NON_ACCEPTANCE_OF_R62_DISHONORED_RETURN,
  VOID_REASON_UNSUCCESSFUL,
]);

export const VOID_REASONS_ACH_RECOVERABLE = Object.freeze([
  VOID_REASON_INSUFFICIENT_FUNDS,
  VOID_REASON_NO_ERRORS_FOUND,
  VOID_REASON_UNSUCCESSFUL,
]);

export const INTERVAL_JUST_THIS_ONCE = 'Just this once';
export const INTERVAL_EVERY_FIRST_AND_FIFTEENTH = 'Every 1st and 15th';
export const INTERVAL_EVERY_FIFTH_AND_TWENTIETH = 'Every 5th and 20th';
export const INTERVAL_EVERY_MONTH = 'Every month';
export const INTERVAL_EVERY_TWO_WEEKS = 'Every two weeks';
export const INTERVAL_EVERY_WEEK = 'Every week';

export const TRANSACTION_METHOD_FLOW_CUSTOM = 'flowcustom';
export const TRANSACTION_METHOD_FLOW_GIVING = 'flowgiving';
export const TRANSACTION_METHOD_FLOW_MANUAL = 'flowmanual';
export const TRANSACTION_METHOD_FLOW_REBELGIVE = 'flow';
export const TRANSACTION_METHOD_MANUAL = 'manual';
export const TRANSACTION_METHOD_SCHEDULE = 'schedule';

export const TRANSACTION_METHODS = Object.freeze([
  TRANSACTION_METHOD_FLOW_CUSTOM,
  TRANSACTION_METHOD_FLOW_GIVING,
  TRANSACTION_METHOD_FLOW_MANUAL,
  TRANSACTION_METHOD_FLOW_REBELGIVE,
  TRANSACTION_METHOD_MANUAL,
  TRANSACTION_METHOD_SCHEDULE,
]);

export const TRANSACTION_METHODS_OFFLINE = Object.freeze([TRANSACTION_METHOD_MANUAL, TRANSACTION_METHOD_FLOW_MANUAL]);

// End copy of constants from RebelPay.

export const SES_MAX_SEND_RATE_COUNT = 24; // emails
export const SES_SAFE_SEND_RATE_COUNT = 0.5 * SES_MAX_SEND_RATE_COUNT;
export const SES_SEND_RATE_TIME = 1 * 1000; // seconds

export const LAMBDA_MAX_CONCURRENCY = 1000;
export const LAMBDA_SAFE_MAX_CONCURRENCY = LAMBDA_MAX_CONCURRENCY / 4;
